<template>
  <div
    class="sidebar"
    @mouseleave="isActive = ''"
  >
    <div class="sidebar__main">
      <div class="sidebar__title-logo">
        <router-link
        :to="{name: 'Dashboard'}"
        class="d-block h-100"
        />
      </div>
      <ul class="sidebar__menu-list">
        <li class="sidebar__menu-item" @mouseover="isActive = ''">
          <router-link
            v-if="hasAuth(['senior', 'admin'])"
            class="sidebar__menu-link"
            :to="{name: 'TutorList'}"
          >
            Tutor Info
          </router-link>
        </li>
        <li v-if="hasAuth(['senior', 'tutor', 'admin'])"
          class="sidebar__menu-item" @mouseover="isActive = 'Tutor Attendance'">
          <div class="sidebar__menu-link">
            Tutor Attendance
          </div>
        </li>
        <li v-if="hasAuth(['senior', 'tutor'])"
          class="sidebar__menu-item" @mouseover="isActive = ''">
          <router-link
            class="sidebar__menu-link"
            :to="{
              name: 'TutorLessonSchedule',
              params: { tutorId },
            }"
          >
            Lesson Schedule
          </router-link>
        </li>
        <li v-if="hasAuth(['senior', 'tutor', 'admin'])"
          class="sidebar__menu-item" @mouseover="isActive = ''">
          <router-link
            class="sidebar__menu-link"
            :to="{name: 'Applications'}"
          >
            Application
          </router-link>
        </li>
        <li v-if="hasAuth(['senior', 'partTimer', 'admin'])"
          class="sidebar__menu-item" @mouseover="isActive = 'Student'">
          <div class="sidebar__menu-link">
            Students
          </div>
        </li>
        <li v-if="hasAuth(['admin'])"
          class="sidebar__menu-item" @mouseover="isActive = ''">
          <router-link
            class="sidebar__menu-link"
            :to="{name: 'CourseImport'}"
          >
            Import Course
          </router-link>
        </li>
        <li v-if="hasAuth(['admin'])"
          class="sidebar__menu-item" @mouseover="isActive = 'Group'">
          <div class="sidebar__menu-link">
            Group
          </div>
        </li>
        <li v-if="hasAuth(['admin'])"
          class="sidebar__menu-item" @mouseover="isActive = 'Mail'">
          <div class="sidebar__menu-link">
            Mail
          </div>
        </li>
        <li v-if="hasAuth(['senior', 'admin'])"
          class="sidebar__menu-item" @mouseover="isActive = 'Evaluation'">
          <div class="sidebar__menu-link">
            Evaluations
          </div>
        </li>
        <li v-if="hasAuth(['senior', 'admin'])"
          class="sidebar__menu-item" @mouseover="isActive = ''">
          <router-link
            class="sidebar__menu-link"
            :to="{name: 'UnfinishedTasks'}"
          >
            Unfinished Task
          </router-link>
        </li>
        <li v-if="hasAuth(['senior', 'admin'])"
          class="sidebar__menu-item" @mouseover="isActive = ''">
          <router-link
            class="sidebar__menu-link"
            :to="{name: 'Deadlines'}"
          >
            Deadline Setting List
          </router-link>
        </li>
        <li v-if="hasAuth(['tutor'])"
          class="sidebar__menu-item" @mouseover="isActive = ''">
          <router-link
            class="sidebar__menu-link"
            :to="{name: 'StampingQr'}"
          >
            Scan QR
          </router-link>
        </li>
        <li v-if="hasAuth(['admin'])"
          class="sidebar__menu-item" @mouseover="isActive = ''">
          <router-link
            class="sidebar__menu-link"
            :to="{name: 'Extras'}"
          >
            Extra list
          </router-link>
        </li>
      </ul>
    </div>
    <div
      v-for="sideMenuItem of sideMenuList"
      :key="sideMenuItem.title"
    >
      <div
        v-show="isActive === `${sideMenuItem.title}`"
        class="sidebar__sub"
      >
        <div class="sidebar__sub-title">{{sideMenuItem.title}}</div>
        <ul class="sidebar__sub-menu-list">
          <li
            v-for="transition of sideMenuItem.transitionList"
            :key="transition.title"
          >
            <router-link
              class="sidebar__sub-menu-item"
              :to="{
                name: transition.pageName,
                params: transition.params,
              }"
            >
              {{ transition.title }}
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import _ from 'lodash'
import moment from 'moment'
import { RootState } from '@/store/types';

export default Vue.extend({
  data(): {
    accessControlList: {
      title: string,
      transitionList: {
        title: string,
        pageName: string,
        params?: Object,
        acceptRoles: string[],
      }[],
    }[],
    isActive: string,
    } {
    return {
      accessControlList: [
        {
          title: 'Tutor Attendance',
          transitionList: [
            {
              title: 'Confirm Clock-in',
              pageName: 'ClockIns',
              params: {
                date: moment().format('YYYYMMDD'),
              },
              acceptRoles: ['senior', 'admin'],
            },
            {
              title: 'Confirm Clock-in',
              pageName: 'ClockInDetail',
              params: {
                tutorId: (this.$store.state as RootState).auth.profile?.id,
              },
              acceptRoles: ['tutor'],
            },
            {
              title: 'Timesheets',
              pageName: 'Timesheets',
              acceptRoles: ['senior', 'admin'],
            },
            {
              title: 'Timesheets',
              pageName: 'TimesheetDetail',
              params: {
                tutorId: (this.$store.state as RootState).auth.profile?.id,
              },
              acceptRoles: ['tutor'],
            },
            {
              title: 'Work summary',
              pageName: 'TimesheetWorkSummary',
              acceptRoles: ['admin'],
            },
          ],
        },
        {
          title: 'Student',
          transitionList: [
            {
              title: 'Student List',
              pageName: 'Students',
              acceptRoles: ['senior', 'partTimer', 'admin'],
            },
            {
              title: 'Student Import',
              pageName: 'ImportStudent',
              acceptRoles: ['admin'],
            },
            {
              title: 'Import WeTEC Scores',
              pageName: 'ImportStudentWetec',
              acceptRoles: ['admin'],
            },
            {
              title: 'Preparation Limit Settings',
              pageName: 'PreparationLimitSetting',
              acceptRoles: ['admin'],
            },
          ],
        },
        {
          title: 'Group',
          transitionList: [
            {
              title: 'Group List',
              pageName: 'Groups',
              acceptRoles: ['admin'],
            },
            {
              title: 'Booth List',
              pageName: 'Booths',
              acceptRoles: ['admin'],
            },
          ],
        },
        {
          title: 'Evaluation',
          transitionList: [
            {
              title: 'Evaluations',
              pageName: 'Evaluations',
              acceptRoles: ['senior', 'admin'],
            },
            {
              title: 'Export Grade Evaluation',
              pageName: 'ExportGradeEvaluation',
              acceptRoles: ['admin'],
            },
          ],
        },
        {
          title: 'Mail',
          transitionList: [
            {
              title: 'Mail List',
              pageName: 'Mails',
              acceptRoles: ['admin'],
            },
            {
              title: 'Mail Template List',
              pageName: 'MailTemplates',
              acceptRoles: ['admin'],
            },
            {
              title: 'Send mail to Students',
              pageName: 'SendMailToStudents',
              acceptRoles: ['admin'],
            },
            {
              title: 'Send mail to Tutors',
              pageName: 'SendMailToTutors',
              acceptRoles: ['admin'],
            },
          ],
        },
      ],
      isActive: '',
    }
  },
  computed: {
    tutorId(): string|undefined {
      return (this.$store.state as RootState).auth.profile?.id
    },
    sideMenuList(): any[] {
      return this.accessControlList.map((acl) => {
        return {
          ...acl,
          transitionList: _.filter(acl.transitionList, (transition) => {
            return this.hasAuth(transition.acceptRoles)
          }),
        }
      })
    },
  },
  methods: {
    hasAuth(acceptRoles: string[]): boolean {
      const auth = (this.$store.state as RootState).auth.profile?.authority
      return _.indexOf(acceptRoles, auth) !== -1
    },
  },
})
</script>

<style scoped>
.sidebar {
  display: flex;
  position: fixed;
  height: 100%;
  left:0px;
  z-index: 100;
}

.sidebar__main {
  background: #003d69;
  border-right: 5px solid #DDEAF6;
  border-left: 5px solid #DDEAF6;
  width: 10%;
  min-width: 170px;
}

.sidebar__sub {
  z-index: 200;
  position: absolute;
  background: rgba(0, 61, 105, 0.8);
  height: 100%;
  width: 10%;
  min-width: 170px;
  color:#fff;
  transition: all 300ms 0s ease;
}

.sidebar__title-logo {
  height: 80px;
  border-bottom:2px solid #DDEAF6;
  margin-bottom:20px;
  background-image: url("~@/assets/logo.jpg");
  background-position:center center;
  background-size: cover;
}

.sidebar__menu-list {
  margin:0;
  padding-inline-start: 0px;
  list-style-type: none;
  max-height: calc(100vh - 9rem);
  overflow-y: auto;
}

.sidebar__menu-item {
  position: relative;
  cursor: pointer;
  user-select:none;
}

.sidebar__menu-link{
  text-decoration: none;
  color:#fff;
  display: block;
  padding:15px 10px;
}

.sidebar__menu-item:hover {
  background: #DDEAF6;
}

.sidebar__sub-title {
  border-bottom:2px solid #DDEAF6;
  margin-top:100px;
  padding-bottom:10px;
  padding-left:10px;
  margin-bottom:20px;
}

.sidebar__sub-menu-list {
  margin:0;
  padding-inline-start: 0px;
  list-style-type: none;
}

.sidebar__sub-menu-item {
  position: relative;
  display: block;
  text-decoration: none;
  color: #fff;
  padding:15px 10px;
  cursor: pointer;
  color: #fff;
}

.sidebar__sub-menu-item:hover {
  background: rgba(221,234,246,0.7);
  color: #000;
}
.sidebar__menu-link:hover {
  color: #000;;
}

/*スクロールバー全体*/
::-webkit-scrollbar {
    width: 10px;
}

/*スクロールバーの軌道*/
::-webkit-scrollbar-track {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, .1);
}

/*スクロールバーの動く部分*/
::-webkit-scrollbar-thumb {
  background-color: #B0C4DE;
  border-radius: 10px;
  box-shadow:0 0 0 1px rgba(255, 255, 255, .3);
}

</style>
